import { ResultPopupModuleState, ResultPopupModuleAction, RESULT_POPUP_MODULE_ACTION } from ".";

export default function reducer(state: ResultPopupModuleState, action: ResultPopupModuleAction): ResultPopupModuleState {
    switch(action.type) {
        case RESULT_POPUP_MODULE_ACTION.HIDE:
            return {
                ...state,
                isDisplayed: false
            }

        case RESULT_POPUP_MODULE_ACTION.SHOW:
            return {
                isDisplayed: true,
                type: action.payload.type,
                triesLeft: action.payload.triesLeft
            }
    }
}
